export function stop_loader ()
{
    //$('#loader-wrapper-img').hide();
    $('#loader-wrapper-img').removeClass('loader-wrapper-test');
    $('#img-loader').removeClass('loader-ring-test');
    $('#overlayrow').remove();
    // $("body").find("*").removeAttr("disabled");
    // $("body").find("a").unbind('click', false);
    // $("input").removeAttr("disabled");
}